import React  from 'react';
import './App.css';
import './Page.css';

import { useNavigate } from "react-router-dom";

class PageEditHtml extends React.Component {

	constructor(props) {

		super(props);
		
		this.state = {
			fileText: "",
			filenameMax: -1,
			dataLoadedYN: false,
		};

		this.downloadTextFile = this.downloadTextFile.bind(this);
		this.serverGetPageFilenameMax = this.serverGetPageFilenameMax.bind(this);
		this.serverSetPageTextFile = this.serverSetPageTextFile.bind(this);
		this.onFileTextChanged = this.onFileTextChanged.bind(this);
		this.onClickSaveButton = this.onClickSaveButton.bind(this);
		this.onClickCancelButton = this.onClickCancelButton.bind(this);
	}

	componentDidMount() {

		var baseURLAPI = this.props.baseURLAPI;
		var modelID = this.props.modelID;
		var pageFolder = this.props.pageFolder;
		var pageSubfolder = this.props.pageSubfolder;

		var newYN = this.props.newYN;
		if (newYN) {
			this.serverGetPageFilenameMax(modelID, pageFolder, pageSubfolder);
			return;
		}

		var pageFilenameExt = this.props.pageFilenameExt;
		var pageURL = baseURLAPI + "/model/" + modelID + "/pages/" + pageFolder + "/" + pageSubfolder;
		var fileURL = pageURL + "/" + pageFilenameExt;
		this.downloadTextFile(fileURL);
	}

	async downloadTextFile(fileURL) {

		var res = await fetch(fileURL);
		var responseText = "";

		try {
			responseText = await res.text();
		} catch {
			responseText = "";
		}

		if (res.status !== 200) {
			responseText = "";
		}
				
		this.setState({
			fileText: responseText,
			dataLoadedYN: true,
		});
	}
	
	async serverGetPageFilenameMax(modelID, pageFolder, pageSubfolder) {

		var baseURLAPI = this.props.baseURLAPI;
		var folder = pageFolder + "/" + pageSubfolder;
		var url = baseURLAPI + "/getpagefilenamemax?modelid=" + modelID;
		url = url + "&folder=" + encodeURIComponent(folder);

		var filenameMax = -1;

		var res = await fetch(url);
		var responseText = "";

		try {
			responseText = await res.text();
			filenameMax = parseInt(responseText);
		} catch {
			filenameMax = -1;
		}

		this.setState({
			filenameMax: filenameMax,
			dataLoadedYN: true,
		});
		
	}
	
	async serverSetPageTextFile(modelID, pageFolder, pageSubfolder, pageFilenameExt, fileText) {
		
		var baseURLAPI = this.props.baseURLAPI;
		var folder = pageFolder + "/" + pageSubfolder;
		var url = baseURLAPI + "/setpagetextfile?modelid=" + modelID;
		url = url + "&folder=" + encodeURIComponent(folder);
		url = url + "&filename=" + encodeURIComponent(pageFilenameExt);
		
		var formData = new FormData();
		formData.append("filetext", fileText);

		const res = await fetch(url, {
			method: 'POST',
			body: formData,
		});		

		await res.text();

		this.props.showToast("Html section saved");
		const navigate = this.props.navigate;
  		navigate("/page");
	}

	onFileTextChanged(value) {
		this.setState({fileText: value});
	}
	
	onClickSaveButton() {
		
		var modelID = this.props.modelID;
		var pageFolder = this.props.pageFolder;
		var pageSubfolder = this.props.pageSubfolder;
		var fileText = this.state.fileText;

		var newYN = this.props.newYN;
		var pageFilenameExt;
		if (newYN) {
			var filenameMax = this.state.filenameMax;
			filenameMax = filenameMax + 1;
			pageFilenameExt = filenameMax + ".html";
		} else {
			pageFilenameExt = this.props.pageFilenameExt;
		}

		this.serverSetPageTextFile(modelID, pageFolder, pageSubfolder, pageFilenameExt, fileText);

		var title;
		var changeJsonObj;
		var changeJSON;

		if (newYN) {
			title = "New page html section: " + pageFolder + "/" + pageSubfolder;
			changeJsonObj = {};
			changeJsonObj.section = "pages";
			changeJsonObj.operation = "newhtmlsection";
			changeJsonObj.pageFolder = pageFolder;
			changeJsonObj.pageSubfolder = pageSubfolder;
			changeJsonObj.fileText = fileText;
			var changeJSON = JSON.stringify(changeJsonObj);
			this.props.serverInsertChangeLogRecord(title, changeJSON);
		} else {
			title = "Edit page html section: " + pageFolder + "/" + pageSubfolder;
			changeJsonObj = {};
			changeJsonObj.section = "pages";
			changeJsonObj.operation = "edithtmlsection";
			changeJsonObj.pageFolder = pageFolder;
			changeJsonObj.pageSubfolder = pageSubfolder;
			changeJsonObj.fileText = fileText;
			var changeJSON = JSON.stringify(changeJsonObj);
			this.props.serverInsertChangeLogRecord(title, changeJSON);
		}
	}
	
	onClickCancelButton() {
		const navigate = this.props.navigate;
  		navigate("/page");
	}

	render() {
		
		var dataLoadedYN = this.state.dataLoadedYN;
		if (!dataLoadedYN) {
			return null;
		}

		var pageFolder = this.props.pageFolder;
		var pageSubfolder = this.props.pageSubfolder;

		return (
			<div className="ViewContainer1">
				<div style={{height: "10px"}}></div>
				<div className="PageEditHtmlTitle">{pageFolder}_{pageSubfolder}</div>
				<div style={{height: "20px"}}></div>
				<textarea
					className="PageEditHtmlInput" 
					id="txtFileText" 
					type="text" 
					rows={25}
					value={this.state.fileText}
					autoFocus={true}
					onChange={(event) => this.onFileTextChanged(event.target.value)}
				/>
				<div style={{height: "20px"}}></div>
				<div className="ViewContainerButtons">
					<div style={{width: "40px"}}></div>
					<button className="ViewCancelButton" onClick={this.onClickCancelButton}>Cancel</button>
					<div style={{width: "20px"}}></div>
					<button className="ViewSaveButton" onClick={this.onClickSaveButton}>Save</button>
				</div>
				<div style={{height: "20px"}}></div>
			</div>
		);
	}
}

export default function PageEditHtmlFunction(props) {
	const navigate = useNavigate();
	return <PageEditHtml {...props} navigate={navigate} />;
}
